import React from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import { Redirect, Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import qs from "qs";

import { getAccount, getAuth } from "../configureStore";
import { login } from "../configureStore/user";
import { parseQuery } from "../utilities";
import { Button, TextField } from "../theme";
import OverlayLoader from "./loader/OverlayLoader";

function LoginForm({
  dispatch,
  auth,
  account,
  redirectionPath,
  hideFetchingOverlay,
}) {
  const { errors, handleSubmit, control } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const { search } = useLocation();
  const as = parseQuery(search).as;

  if (auth.isConnected && redirectionPath) {
    return <Redirect to={redirectionPath} />;
  }

  function onSubmit(data) {
    dispatch(login({ ...data, as }));
  }

  return (
    <section style={{ position: "relative" }}>
      {!hideFetchingOverlay && (
        <OverlayLoader
          isVisible={account.isFetching}
          error={account.error != null}
        />
      )}
      <h2>Je me connecte</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          <Controller
            as={TextField}
            label="Adresse e-mail"
            type="email"
            name="email"
            control={control}
            rules={{
              required: "L'adresse email est requise.",
              pattern: {
                value:
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "L'adresse email doit être valide.",
              },
            }}
            required
            error={errors.email !== undefined}
            helperText={errors.email && errors.email.message}
          />
        </fieldset>
        <fieldset>
          <Controller
            as={TextField}
            label="Mot de passe"
            type="password"
            name="password"
            control={control}
            rules={{
              required: "Le mot de passe est requis.",
              minLength: {
                value: 6,
                message: "Votre mot de passe doit faire au moins 6 caractères.",
              },
            }}
            required
            error={errors.password !== undefined}
            helperText={errors.password && errors.password.message}
          />
        </fieldset>

        {account.error && <p className="error">{account.error}</p>}

        <div>
          <Button type="submit">Connexion</Button>
          <Link to="/mot-de-passe">Mot de passe oublié ?</Link>
        </div>
      </form>
    </section>
  );
}

LoginForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    isConnected: PropTypes.bool.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  redirectionPath: PropTypes.string,
  hideFetchingOverlay: PropTypes.bool,
};

export default connect((state) => ({
  account: getAccount(state),
  auth: getAuth(state),
}))(LoginForm);
